export default __webpack_public_path__ + "static/media/ukraine.52191a19.svg";